// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bu-4";
export var collapsed = "_bu-1";
export var headerBar = "_bu-0";
export var leftHeaderContent = "_bu-3";
export var subjectContainer = "_bu-2";